import { Component, inject, signal } from '@angular/core';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatDivider } from '@angular/material/divider';
import { MatIcon } from '@angular/material/icon';
import { DebugModeService } from '@raxapp/debugging/debug-mode.service';

export class ShowErrorNotificationDetailsDialogData {
    public errorReason!: string;

    constructor(init: ShowErrorNotificationDetailsDialogData) {
        Object.assign(this, init);
    }
}

@Component({
    selector: 'rax-show-error-notification-details-dialog',
    templateUrl: './show-error-notification-details-dialog.component.html',
    imports: [MatIcon, MatDivider, MatButton, MatIconButton, MatDialogActions, MatDialogTitle, MatDialogContent],
})
export class ShowErrorNotificationDetailsDialogComponent {
    private readonly dialogRef: MatDialogRef<ShowErrorNotificationDetailsDialogComponent, void> = inject(MatDialogRef);
    private readonly dialogData: ShowErrorNotificationDetailsDialogData = inject(MAT_DIALOG_DATA);
    private readonly debugModeService = inject(DebugModeService);

    public readonly debugModeIsActive = this.debugModeService.isActive;
    public readonly errorReason = signal<string>(this.dialogData.errorReason).asReadonly();

    public onCloseDialogButtonClick(): void {
        this.dialogRef.close(undefined);
    }

    public onCloseDialogActionButtonClick(): void {
        this.dialogRef.close(undefined);
    }
}
